import { TotalVolumesCard } from "./TotalVolumesCard";
import { WorstAffectedCard } from "./WorstAffectedCard";
import { MonitoringStatsCard } from "./MonitoringStatsCard";

export const SummaryMetrics = () => {
	return (
		<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
			<TotalVolumesCard />
			<WorstAffectedCard />
			<MonitoringStatsCard />
		</div>
	);
};
